import { BaseAccordion } from '../../../../../Accordion/BaseAccordion';
import { ColumnMapping } from '../InstrumentIdentifiers/components/ColumnMapping/ColumnMapping';
import { ValidationBadge } from '../../ValidationBadge/ValidationBadge';
import { SingleColumnSectionProps } from './types';
import { useSingleColumnSection } from './useSingleColumnSection';

export const SingleColumnSection = (props: SingleColumnSectionProps) => {
  const {
    title,
    sectionId,
    templateId,
    instrumentType,
    availableHeaders = [],
    expanded,
    onChange,
  } = props;

  const { validationResult } = useSingleColumnSection(props);

  return (
    <BaseAccordion
      title={title}
      expanded={expanded}
      onChange={onChange}
      badge={<ValidationBadge validationResult={validationResult} />}
    >
      <ColumnMapping
        templateId={templateId}
        instrumentType={instrumentType}
        sectionId={sectionId}
        availableHeaders={availableHeaders}
        singleMode={true}
      />
    </BaseAccordion>
  );
};
